import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AirlineSeatReclineExtraIcon(props: IconProps) {
    return <Icon {...props} iconKey={"airline_seat_recline_extra"}/>
}
